import { SearchIcon } from "@heroicons/react/outline";
import { Pagination, Tab, Tabs } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductList from "../Componants/ProductList";
import { showToast } from "../Controllers/Toast";
import { addToCartProduct, getAllProducts, getMembershipProduct, getScannedBarcodeProduct } from "../Redux/Action/catelog.action";
const Cashier = () => {
  const dispatch = useDispatch();
  const { staffInfo, currency } = useSelector((state) => state?.authReducer);
  const { allProducts } = useSelector((state) => state.catelogReducer);
  const [tabValue, setTabValue] = useState("Newest");
  const [cardOpen, setCardOpen] = useState("");
  const [Page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [search, setSearch] = useState();
  const [allProCount, setAllProCount] = useState(0);
  const { discountInfo, orderLoader } = useSelector((state) => state.orderReducer);
  const location_id = localStorage.getItem("location_id");
  const currencyRate = currency && (currency?.find((c) => c.name === staffInfo?.client?.currency_format)?.rate[0] ?? 1);
  var startRecord = (allProducts?.data?.currentPage - 1) * limit + 1;
  var endRecord = Math.min(allProducts?.data?.currentPage * limit, allProducts?.data?.totalRecords);
  useEffect(() => {
    if (tabValue === "Membership") {
      dispatch(getMembershipProduct());
    } else {
      if (!search || search.length > 2) {
        dispatch(getAllProducts(Page, limit, search, cardOpen, tabValue, true, "in_stock"));
      }
    }
  }, [search, Page, tabValue, cardOpen]);
  useEffect(() => {
    if (cardOpen === "" && tabValue !== "Membership") {
      setAllProCount(allProducts?.data?.totalRecords);
    } else if (tabValue === "Membership") {
      setAllProCount(allProducts?.data?.length);
    }
  }, [cardOpen]);
  const categories = allProducts?.data?.categoriesWiseProduct;

  const bufferRef = useRef("");
  const timerRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = async (e) => {
      // Ignore modifiers
      if (e.ctrlKey || e.altKey || e.metaKey) return;

      // ENTER = barcode finished
      if (e.key === "Enter") {
        const scannedBarcode = bufferRef.current.trim();
        bufferRef.current = "";

        if (!scannedBarcode) return;
        // 🔥 Call API with barcode
        const res = await dispatch(getScannedBarcodeProduct(scannedBarcode));

        const product = res?.data?.data;

        if (!product) {
          showToast.error("Product not found");
          return;
        }

        // ✅ Add to cart
        addToCart({ stopPropagation: () => { } }, product);
        return;
      }

      // Accept printable chars only
      if (e?.key?.length === 1) {
        bufferRef.current += e.key;
      }

      // Clear buffer if manual typing
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        bufferRef.current = "";
      }, 50);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const addToCart = (e, data) => {
    e.stopPropagation();

    const cart = JSON.parse(localStorage.getItem("addToCart")) ?? {
      products: [],
      status: "completed",
      channel: "pos",
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
      adjust_discount: 0,
      adjust_discount_type: "amount",
    };

    let existingProduct = cart.products?.find((item) => item.product === data?._id);

    // If product exists → increase quantity
    if (existingProduct) {
      existingProduct.quantity += 1;
      existingProduct.product_total = existingProduct.selling_price * existingProduct.quantity;
    } else {
      // Add new product
      const date = new Date();
      date.setDate(date.getDate() + Number(data?.product_replacement_days));

      cart.products.push({
        product: data?._id,
        name: data?.product_name,
        image: data?.additional_images?.[0],
        sku_id: data?.sku_id,
        quantity: 1,
        selling_price: data?.selling_price || data?.mrp,
        mrp: data?.mrp || data?.selling_price,
        total_quantity: data?.product_type === "membership" ? 1 : data?.quantity,
        product_total: (data?.selling_price || data?.mrp) * 1,
        product_type: data?.product_type,
        variant: data?.variant,
        dimension: data?.dimension,
        weight: data?.weight,
        product_return_policy: data?.product_return_policy,
        product_replacement_days: data?.product_replacement_days,
        ...(data?.product_replacement_days > 0 && {
          return_valid_till_date: date,
        }),
        is_return: data?.is_return,
        cgst: data?.cgst,
        sgst: data?.sgst,
      });
    }

    const calculateTotalPrice = (products) => products.reduce((total, product) => total + product?.selling_price * product?.quantity, 0);

    const calculateTotalDiscount = (total_price) => {
      if (!discountInfo || !discountInfo.data) {
        return 0;
      }

      const discountType = discountInfo?.data?.discount_Type;
      const discountValue = discountInfo?.data?.discount;

      if (discountType === "percentage") {
        return total_price * (discountValue / 100);
      } else if (discountType === "amount") {
        return discountValue / currencyRate;
      }
      return 0;
    };

    const calculateAdjustDiscount = (currentTotalPrice) => {
      const adjustDiscountType = cart.adjust_discount_type;
      const adjustDiscountValue = cart.adjust_discount ?? 0;
      if (adjustDiscountType === "percentage") {
        return currentTotalPrice * (cart?.adjust_discount_percentage / 100);
      } else if (adjustDiscountType === "amount") {
        return adjustDiscountValue / currencyRate;
      }

      return 0;
    };

    const total_price = calculateTotalPrice(cart.products);
    const discount = calculateTotalDiscount(total_price);
    const adjustDiscount = calculateAdjustDiscount(total_price - discount);
    const calculateMembershipDiscount = () => {
      if (!cart?.pos_membership) {
        return 0;
      }
      const membershipType = cart?.pos_membership_discount_type;
      const membershipValue = cart?.pos_membership_discount;
      if (membershipType === "percentage") {
        return total_price * (cart?.pos_membership_discount_percentage / 100);
      } else if (membershipType === "amount") {
        return membershipValue / currencyRate;
      }

      return 0;
    };
    const membershipDiscount = calculateMembershipDiscount();
    cart.total_price = total_price - discount - adjustDiscount - membershipDiscount;
    cart.sub_total = total_price;
    cart.total_discount = discount;
    cart.adjust_discount = adjustDiscount;
    cart.adjust_discount_type = cart.adjust_discount_type || "amount";
    cart.cash_amount = 0;
    cart.pos_membership_discount = membershipDiscount;

    localStorage.setItem("addToCart", JSON.stringify(cart));
    dispatch(addToCartProduct(cart));
  };
  return (
    <>
      <div className="header flex flex-wrap gap-4 items-center justify-between">
        <Tabs
          textColor="black"
          className="border-b"
          TabIndicatorProps={{ style: { backgroundColor: "black" } }} // Black indicator for active tab
          value={tabValue}
          onChange={(e, v) => setTabValue(v)}
          aria-label="basic tabs example"
        >
          <Tab label="Newest" value={"Newest"} />
          <Tab label="Best Seller" value={"BestSeller"} />
          {/* <Tab label="Discount Products" value={"product_discount"} /> */}
          <Tab label="Membership Products" value={"Membership"} />
        </Tabs>
        <div className="flex gap-2 items-center justify-end">
          <div className="relative">
            <SearchIcon className="input-icon w-5 h-5" />
            <input type="text" placeholder="Type 3 character to search" className="!pl-10" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          {/* <button type="button" className="square-btn" onClick={() => setOpenCam(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
              />
            </svg>
          </button> */}
          <button className="square-btn">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="category flex flex-wrap gap-4 mt-4">
        <div className={`card space-x-3 ${cardOpen === "" && "active-card"}`} onClick={() => setCardOpen("")}>
          <div className="card-img">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
              />
            </svg>
          </div>
          <div>
            <h6 className="font-semibold text-base">All Product</h6>
            <p className=" text-sm">{`${allProCount} items`}</p>
          </div>
        </div>
        {categories?.length > 0 &&
          categories?.map((elem, index) => (
            <div key={index} className={`card space-x-3 ${cardOpen === elem?._id && "active-card"}`} onClick={() => setCardOpen(elem?._id)}>
              <div className="card-img">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
                  />
                </svg>
              </div>
              <div>
                <h6 className="font-semibold text-base">{elem?.category_name}</h6>
                <p className="text-sm">{`${elem?.count} items`}</p>
              </div>
            </div>
          ))}
      </div>
      <ProductList />
      {allProducts?.data?.totalPages ? (
        <div className="bg-white border main-border-color flex flex-1 p-5 items-center justify-between pagination overflow-hidden rounded-[6px] mt-4">
          <span className="text-sm font-medium">{limit === "all" ? `${allProducts?.data?.totalRecords}` + " " + `records` : `${startRecord} - ${endRecord} of ${allProducts?.data?.totalRecords} records`}</span>
          <div>{allProducts?.data?.totalPages !== 1 ? <Pagination count={allProducts?.data?.totalPages} page={Page} onChange={(e, v) => setPage(v)} /> : ""}</div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Cashier;
